import { render } from "./Leads.vue?vue&type=template&id=56bb020c&scoped=true&ts=true"
import script from "./Leads.vue?vue&type=script&lang=ts"
export * from "./Leads.vue?vue&type=script&lang=ts"

import "./Leads.vue?vue&type=style&index=0&id=56bb020c&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_omnia_1776687441006616365/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bb020c"]])

export default __exports__